import React from "react";
import {connect} from "react-redux";
import {hidePopup} from "../../actions/showPopup";

class LayoutPopup extends React.Component
{
	render()
	{
		const {popup, hidePopup} = this.props;

		if (!popup) {
			return null;
		}

		return (
			<div className="popup">
				<div className="popup-container">
					<div className="popup-body">
						{popup.text}
					</div>
					<div className="popup-footer">
						<button onClick={() => hidePopup()}>OK</button>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (store) => ({
	popup: store.popup,
});

const mapDispatchToProps = (dispatch) => ({
	hidePopup: () => dispatch(hidePopup()),
});

export default connect(mapStateToProps, mapDispatchToProps)(LayoutPopup);
